module.exports = __webpack_public_path__ + "img/lunatic_goblin_small.8f6d29da.png";